import { render, staticRenderFns } from "./messageItem.vue?vue&type=template&id=2e646b51&scoped=true&"
import script from "./messageItem.vue?vue&type=script&lang=js&"
export * from "./messageItem.vue?vue&type=script&lang=js&"
import style0 from "./messageItem.vue?vue&type=style&index=0&id=2e646b51&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e646b51",
  null
  
)

export default component.exports